
// import { useIntl } from 'react-intl'
// import { AsideMenuItemWithSub } from './AsideMenuItemWithSub'
import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { useAuth } from '../../../../app/modules/auth'
import { AsideMenuItem } from './AsideMenuItem'
import { checkIsActive, KTSVG } from '../../../helpers'
import { useLayout } from '../../core'
import { useSuperAdminMode } from '../../../../app/modules/super-admin/context/SuperAdminModeContext'
import { hasPlanFeature } from '../../../../app/helper-functions/planGate'

export function AsideMenuMain(): React.JSX.Element {
  // const intl = useIntl()

  const { config } = useLayout()
  const { aside } = config
  const { currentUser } = useAuth()
  const { isInvitedByOrganization , role} = currentUser?.data?.user
  const { pathname } = useLocation()
  const isHomeActive = checkIsActive(pathname, '/home/board')
  const { isSuperAdminMode } = useSuperAdminMode()
  // integrations.docusign is the plan gate for the whole Integrations page,
  // not just the DocuSign row.
  const docusignEnabled = hasPlanFeature(currentUser, 'integrations.docusign')

  // ---- Super Admin Menu ----
  if (isSuperAdminMode) {
    return (
      <>
        <div className='menu-item'>
          <div className='menu-content pb-2'>
            <span className='menu-section text-muted text-uppercase ls-1 fs-8 fw-bold'>Admin Panel</span>
          </div>
        </div>

        <AsideMenuItem to='/admin/dashboard' title='Dashboard' icon='/media/icons/duotune/art/art002.svg' />
        <AsideMenuItem to='/admin/analytics' title='Analytics' icon='/media/icons/duotune/graphs/gra001.svg' comingSoon />

        <div className='menu-item'><div className='menu-content pt-3 pb-2'><span className='menu-section text-muted text-uppercase ls-1 fs-9 fw-bold'>Billing</span></div></div>
        <AsideMenuItem to='/admin/plans' title='Plans' icon='/media/icons/duotune/finance/fin006.svg' />
        <AsideMenuItem to='/admin/coupons' title='Coupons' icon='/media/icons/duotune/ecommerce/ecm010.svg' />
        {/* Hidden for now — global Coupon Assignments page still reachable at
            /admin/coupon-assignments; assignment lives in the User detail panel
            and the per-coupon Assignments modal.
        <AsideMenuItem to='/admin/coupon-assignments' title='Coupon Assignments' icon='/media/icons/duotune/ecommerce/ecm008.svg' /> */}
        <AsideMenuItem to='/admin/owners' title='Owners' icon='/media/icons/duotune/communication/com013.svg' />
        <AsideMenuItem to='/admin/stripe' title='Stripe' icon='/media/icons/duotune/finance/fin002.svg' comingSoon />

        <div className='menu-item'><div className='menu-content pt-3 pb-2'><span className='menu-section text-muted text-uppercase ls-1 fs-9 fw-bold'>Management</span></div></div>
       
        <AsideMenuItem to='/admin/users' title='Users' icon='/media/icons/duotune/communication/com014.svg' />
        <AsideMenuItem to='/admin/features' title='Feature Registry' icon='/media/icons/duotune/coding/cod009.svg' />
        <AsideMenuItem to='/admin/feature-flags' title='Feature Flags' icon='/media/icons/duotune/coding/cod003.svg' comingSoon />
        <AsideMenuItem to='/admin/announcements' title='Announcements' icon='/media/icons/duotune/general/gen007.svg' />

        <div className='menu-item'><div className='menu-content pt-3 pb-2'><span className='menu-section text-muted text-uppercase ls-1 fs-9 fw-bold'>Tools</span></div></div>
        <AsideMenuItem to='/admin/bulk-actions' title='Bulk Actions' icon='/media/icons/duotune/general/gen019.svg' />
        <AsideMenuItem to='/admin/impersonate' title='Impersonate' icon='/media/icons/duotune/communication/com005.svg' comingSoon />
        <AsideMenuItem to='/admin/tickets' title='Support Tickets' icon='/media/icons/duotune/communication/com012.svg' comingSoon />

        <div className='menu-item'><div className='menu-content pt-3 pb-2'><span className='menu-section text-muted text-uppercase ls-1 fs-9 fw-bold'>System</span></div></div>
        <AsideMenuItem to='/admin/roles' title='Roles & Admins' icon='/media/icons/duotune/general/gen049.svg' comingSoon />
        <AsideMenuItem to='/admin/audit-log' title='Audit Log' icon='/media/icons/duotune/general/gen032.svg' comingSoon />
        <AsideMenuItem to='/admin/settings' title='Settings' icon='/media/icons/duotune/coding/cod001.svg' comingSoon />
        <AsideMenuItem to='/admin/data' title='Global Data' icon='/media/icons/duotune/graphs/gra010.svg' comingSoon />
      </>
    )
  }

  // ---- Normal User Menu ----
  return (
    <>
      <div className='menu-item'>
        <div className={`menu-link without-sub d-flex align-items-center justify-content-between${isHomeActive ? ' active' : ''}`}>
          <Link to='/home/board' className='d-flex align-items-center flex-grow-1 text-decoration-none'>
            <span className='menu-icon'>
              <KTSVG path='/media/icons/duotune/aside-icons/home.svg' className='svg-icon-2' />
            </span>
            <span className='menu-title'>Home</span>
          </Link>
          {aside.minimize && (
            <div
              id='kt_aside_toggle'
              className='btn btn-icon w-auto px-0 btn-active-color-primary aside-toggle bg-transparent'
              data-kt-toggle='true'
              data-kt-toggle-state='active'
              data-kt-toggle-target='body'
              data-kt-toggle-name='aside-minimize'
            >
              <KTSVG
                path='/media/icons/duotune/arrows/arr080.svg'
                className='svg-icon-1 rotate-180'
              />
            </div>
          )}
        </div>
      </div>

      {role?.isGuest === true ? (
        <AsideMenuItem to='/board/other-boards' title='Shared with me' icon='/media/icons/duotune/aside-icons/other-board.svg' />
      ) : (
        <>
          <AsideMenuItem to='/board/my-boards' title='My boards' icon='/media/icons/duotune/aside-icons/my-board.svg' />
          <AsideMenuItem to='/board/other-boards' title='Shared with me' icon='/media/icons/duotune/aside-icons/other-board.svg' />
          {/* <AsideMenuItem to='/board/archived-boards' title='Archived Boards' icon='/media/icons/duotune/aside-icons/archieve-board.svg' /> */}
          <AsideMenuItem
            to='/my-reminders'
            icon='/media/icons/duotune/general/gen007.svg'
            title="Coming up"
          />
          <AsideMenuItem
            to='/templates'
            icon='/media/icons/duotune/aside-icons/templates.svg'
            title="Templates"
          />
          <AsideMenuItem
            to='/manage-contacts'
            icon='/media/icons/duotune/communication/com005.svg'
            title="Contacts"
          />
          {!isInvitedByOrganization && (
            <AsideMenuItem
              to='/manage-account'
              icon='/media/icons/duotune/aside-icons/template-2.svg'
              title="Workspace"
            />
          )}
          {!role?.isGuest && docusignEnabled && (
            <AsideMenuItem
              to='/integrations'
              icon='/media/icons/duotune/social/soc002.svg'
              title="Integrations"
            />
          )}
        </>
      )}

    </>

  )
}
